/*
 * Copyright 2022 Siemens
 */

import React from 'react';
import {Datastore} from '../common/datastore';
import {DatastoreItem, Datastores} from '../services/datastores';
import {Content} from '../common/content';

interface ParameterSetState {
  isLoading: boolean;
  items: ReadonlyArray<DatastoreItem>;
}

export class ParameterSet extends React.Component<{}, ParameterSetState> {
  readonly #symbol = Symbol('ParameterSet');

  constructor(props: {}, state: ParameterSetState) {
    super(props, state);
    this.state = {isLoading: true, items: []};
  }

  override componentDidMount() {
    if (super.componentDidMount) super.componentDidMount();
    Datastores.parameterSetItems.addObserver(this.#symbol, (value) => {
      this.setState({isLoading: value === null, items: value === null ? [] : value});
    });
  }

  override componentWillUnmount() {
    Datastores.parameterSetItems.removeObserver(this.#symbol);
    if (super.componentWillUnmount) super.componentWillUnmount();
  }

  #reloadData(): void {
    this.setState({isLoading: true});
    Datastores.reloadDatastore();
  }

  override render() {
    return (
      <Content
        section='Datastore: Parameter Set'
        isLoading={this.state.isLoading}
      >
        <Datastore
          type='Parameter set'
          items={this.state.items}
          reloadCommand={() => this.#reloadData()}
        />
      </Content>
    );
  }
}
